/* Sepet "Ödemeye geç" → önce ZORUNLU teslimat/fatura adımı (Patron, 27 Eyl 2026).
   Sepet formundaki bekleyen değişiklikler (adet, not) önce /cart/update.js ile kaydedilir —
   düz yönlendirme onları kaybederdi. Kayıt düşerse yine adıma gidilir (ödeme engellenmez).
   Ürün sayfası hızlı ödeme düğmeleri tema ayarında KAPALI (show_dynamic_checkout_buttons=false). */
(function () {
  var ADIM = '/pages/teslimat-adresi';
  // Adım sayfasında da çalışır: oradaki yan sepetten "Ödemeye geç" adımı ATLATIYORDU (28 Eyl).
  // Adımın kendi formu name="checkout" butonu kullanmaz (gizli input), yakalanmaz.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"], a[href="/checkout"]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var form = btn.form || (btn.getAttribute('form') && document.getElementById(btn.getAttribute('form'))) || btn.closest('form');
    var git = function () { window.location.href = ADIM; };
    if (!form) return git();
    try {
      var fd = new FormData(form);
      fd.delete('checkout');
      fetch('/cart/update.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
        .then(git, git);
    } catch (err) { git(); }
  }, true);
})();
